<template>
  <div
    :class="`
      workbench-sequence-waggon-tab
      ${color}
      ${color.includes('lighten') || color.includes('darken')? '':'lighten-1'}
      ${selected?`tab-selected`:'tab-non-selected'}
      `"
    :style="`width: ${width}; color: ${text_color} !important`"
    >
    <TIcon
      :name="getNewIcon(icon)"
      class="cursor-pointer"
      :color="text_color?text_color:'black'"
      />
    <div class="ml-1 workbench-sequence-waggon-tab-content">
      <slot name="content"/>
    </div>
    <v-spacer/>
    <div class="mr-1 workbench-sequence-waggon-tab-actions">
      <slot name="actions"/>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  import TIcon from '@/components/Taktify/TIcon.component.vue'
  export default {
    props: ['color', 'text_color', 'token', 'icon', 'width', 'selected'],
    components: {
      TIcon
    },
    computed: {
      ...mapGetters('WorkPackage', [
        'getNewIcon'
      ])
    }
  }
</script>
<style>
  .workbench-sequence-waggon-tab {
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    transition: all 0.2s ease-in-out;
    border-radius: 3px 3px 0px 0px;
    padding: 3px;
  }
  .workbench-sequence-waggon-tab-content {
    display: flex;
  }
  .workbench-sequence-waggon-tab-actions {
    display: flex;
    align-items: center;
  }
  .tab-selected {
    box-shadow:
      0px 0px 5px 0px rgba(0, 0, 0, 0.5)
      !important;
    z-index: 20 !important;
  }
  .tab-non-selected {
    /* box-shadow:
      inset 0px 0px 5px 0px rgba(0, 0, 0, 0.5)
      !important; */
  }
</style>
